// TBD: Optimize the menu structure to retrieve data automatically from the backend
export const menu = [
    {
        icon: "",
        title: "Total Commodities Programs (Title I)"
    },
    {
        icon: "",
        title: "Total Commodities Programs, Subtitle A"
    },
    {
        icon: "",
        title: "Agriculture Risk Coverage (ARC)",
        items: [
            {
                title: "Agriculture Risk Coverage County Option (ARC-CO)"
            },
            {
                title: "Agriculture Risk Coverage Individual Coverage (ARC-IC)"
            }
        ]
    },
    {
        icon: "",
        title: "Price Loss Coverage (PLC)"
    },
    {
        icon: "",
        title: "Dairy Margin Coverage, Subtitle D"
    },

    {
        icon: "",
        title: "Supplemental Agricultural Disaster Assistance, Subtitle E",
        items: [
            {
                title: "Emergency Assistance for Livestock, Honey Bees, and Farm-Raised Fish Program (ELAP)"
            },
            { title: "Livestock Forage Program (LFP)" },
            {
                title: "Livestock Indemnity Payments (LIP)"
            },
            {
                title: "Tree Assistance Program (TAP)"
            }
        ]
    }
];
